// Assembles and validates the default onboarding policy. Parsing at module load
// fail-fasts on malformed config — the same guarantee we want when this later
// comes from a database.

import { onboardingPolicySchema, type OnboardingPolicy } from '../schema.js';

import { defaultStages } from './flows.js';
import { canadaProfile, countryJurisdiction, euProfile } from './jurisdictions.js';

export const defaultOnboardingPolicy: OnboardingPolicy = onboardingPolicySchema.parse({
  version: '2026-07-27',
  // Default to the jurisdiction the demo backend actually serves (EUR / IBAN),
  // so the default journey is internally consistent. Canada stays selectable to
  // demonstrate jurisdiction-driven config (its CAD/account-number profile is
  // aspirational until the backend issues non-EUR accounts).
  defaultJurisdiction: 'EU',
  countryJurisdiction,
  jurisdictions: [canadaProfile, euProfile],
  stages: defaultStages,
} satisfies OnboardingPolicy);
